import COS from 'cos-js-sdk-v5';
import { v4 as uuidv4 } from 'uuid';

import { TIMEOUT } from '@/utils/const';

import { MIN_PART_SIZE, PARALLEL } from '../../constants';
import { IStoreItem, ITokenData } from '../../type';
import { IInitResponse, IUploadOptions, IUploadRetryOptions, UploaderBase } from './base';

// COS上传
export class CosUploader implements UploaderBase {
  constructor(private timeout: number = TIMEOUT) {}

  // 初始化
  public async init(tokenData: ITokenData): Promise<IInitResponse> {
    try {
      const cosOptions = this.getCosOptions(tokenData);
      const client = new COS(cosOptions);
      const uploadId = uuidv4();
      return {
        uploadId,
        client,
      };
    } catch (error) {
      console.error(error);
      return { uploadId: '', client: null };
    }
  }

  // 批量上传
  public async upload(params: IUploadOptions) {
    const { client, filePath, file, tokenData, options } = params;
    const { region, bucket } = tokenData;

    const { progress } = options;
    let uploadId = '';
    return new Promise((resolve, reject) => {
      (client as COS).sliceUploadFile(
        {
          Bucket: bucket,
          Region: region,
          Key: filePath,
          Body: file,
          onTaskReady: function (taskId) {
            uploadId = taskId;
          },
          onHashProgress: function (progressData) {},
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
            const { loaded, total, percent } = progressData;
            const checkpoint = {
              Bucket: bucket,
              Key: filePath,
              uploadId,
              loaded,
              total,
              percent,
            };
            const lastPercent = percent >= 1 ? 0.99 : percent;
            progress(lastPercent, checkpoint);
          },
          Headers: { 'cache-control': '', 'Content-Disposition': 'attachment' },
        },
        (error: any, data) => {
          if (error) {
            console.error(error);
            reject(error);
            // throw Error(error);
          } else {
            const checkpoint = {
              Bucket: bucket,
              Key: filePath,
              uploadId,
              loaded: 1,
              total: file.size,
              percent: 1,
            };
            progress(1, checkpoint);
            resolve(tokenData?.accessUrl || '');
          }
        },
      );
    });
  }

  // 取消上传
  public async cancel(params: IStoreItem) {
    const { client: _client, tokenData, progressData } = params;
    const { filePath } = tokenData;
    const { checkPoint, transCodeHandler } = progressData;
    transCodeHandler && transCodeHandler();

    if (!checkPoint) return true;
    let client = _client;
    if (!client) {
      const cosOptions = this.getCosOptions(tokenData);
      client = new COS(cosOptions);
    }
    const path = (checkPoint && checkPoint?.name) || filePath;
    const uploadId = checkPoint && checkPoint?.uploadId;
    try {
      (client as COS).cancelTask(uploadId);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  // 重试
  public async retry(params: IUploadRetryOptions) {
    const { info, options } = params;
    const { tokenData, client, file, progressData } = info;
    const { filePath } = tokenData;
    if (client) {
      return await this.upload({
        client,
        filePath,
        file,
        tokenData,
        options,
        uploadId: progressData.checkPoint?.uploadId || '',
      });
    } else {
      const cosOptions = this.getCosOptions(tokenData);
      const client = new COS(cosOptions);
      return await this.upload({
        client,
        filePath,
        file,
        tokenData,
        options,
        uploadId: progressData.checkPoint?.uploadId || '',
      });
    }
  }

  // 获取Oss Options
  private getCosOptions(tokenData: ITokenData) {
    const { uploadHost, bucket, region, accessKey, accessSecret, securityToken } =
      tokenData;
    const { host } = new URL(uploadHost);
    return {
      Timeout: this.timeout || TIMEOUT,
      //   endpoint: `https://${bucket}.${host}`,
      //   region,
      Protocol: 'https:',
      Domain: `${bucket}.cos.${region}.myqcloud.com`,
      SecretKey: accessSecret,
      SecretId: accessKey,
      SecurityToken: securityToken,
      //   bucket,
      //   cname: true,
    };
  }
}
